import { TemplateSection, TemplateField, SectionFieldOption } from '../_types';

/**
 * Filters out soft-deleted sections from a template
 * @param sections - Array of template sections
 * @returns Array of active (non-deleted) sections
 */
export const filterActiveSections = (sections: TemplateSection[]): TemplateSection[] => {
  return sections.filter((section) => !section.effectiveIsDeleted);
};

/**
 * Filters out soft-deleted fields from a section
 * @param fields - Array of template fields
 * @returns Array of active (non-deleted) fields
 */
export const filterActiveFields = (fields: TemplateField[]): TemplateField[] => {
  return fields.filter((field) => !field.effectiveIsDeleted);
};

/**
 * Filters out soft-deleted field options
 * @param options - Array of section field options
 * @returns Array of active (non-deleted) options
 */
export const filterActiveFieldOptions = (options: SectionFieldOption[]): SectionFieldOption[] => {
  return options.filter((option) => !option.effectiveIsDeleted);
};

/**
 * Filters out soft-deleted sections and fields from a template
 * @param sections - Array of template sections
 * @returns Array of active sections with active fields
 */
export const filterActiveContent = (sections: TemplateSection[]): TemplateSection[] => {
  return filterActiveSections(sections).map((section) => ({
    ...section,
    sectionFields: filterActiveFields(section.sectionFields),
  }));
};
